import { createSearchParams } from 'react-router-dom';
import type { To } from 'react-router-dom';

import { optionsService } from '@/services/instance/optionsService';

interface QueryParams {
    email: string | null | undefined;
    [other: string]: unknown;
}

function getQuery({ email, resumeUrl, ...other }: QueryParams): string {
    return createSearchParams({
        ...other,
        r: optionsService.getAppId(),
        ...(email && { email }),
    }).toString();
}

export function getLoginUrl(queryParams: QueryParams): To {
    return {
        pathname: '/login',
        search: getQuery(queryParams),
    };
}

export function getRegistrationUrl(queryParams: QueryParams): To {
    return {
        pathname: '/register',
        search: getQuery(queryParams),
    };
}

export function getRestoreUrl(queryParams: QueryParams): To {
    return {
        pathname: '/restore-password',
        search: getQuery(queryParams),
    };
}

export function getSelectSamlUrl(queryParams: QueryParams): To {
    return {
        pathname: '/sso-login',
        search: getQuery(queryParams),
    };
}
